import api, {
  PaginateRequest,
  PaginateResponse,
  ResponseCallback,
  ResponseAndErrorCallback,
} from '../services/api.service'
import routeUtil from '../utils/route.util'
import { CaseData } from './inventoryCase.api'
import { PackTraceBundleData } from './packTraceBundle.api'
import { UserData } from './user.api'
import { WorkOrderData } from './workOrder.api'

export interface PackTraceData {
  id: number
  siteId: number
  workOrderId: number
  createdBy: number
  lineNumber: string
  createdAt: string
  latitude?: number
  longitude?: number
  caseCode?: string
  palletCode?: string
  case?: CaseData
  workOrder?: WorkOrderData
  bundles?: PackTraceBundleData[]
  createdUser?: UserData
}

export interface PackTraceCreateRequest {
  workOrder?: number
  lineNumber?: string
  pallet?: string
  case?: string
  bundles?: string[]
  latitude?: number
  longitude?: number
}

export interface PackTraceValidatePackCodeRequest {
  workOrder?: number
  packCode?: string
}

export interface ManagerUpcRequest {
  managerUser?: string
  password?: string
}

type PackTracePaginateResponse = PaginateResponse<PackTraceData[]>

export interface PackTraceValidatePackCodeResponse {
  valid: true
}

export interface PackTraceValidatePalletCodeResponse {
  valid: true
}

const routes = {
  create: '/packTraces',
  paginate: '/packTraces/paginate',
  read: '/packTraces/{id}',
  validatePackCode: '/packTraces/packCode/validate',
  validatePalletCode: '/packTraces/palletCode/{code}/validate',
  upcUnblock: '/packTraces/packCode/upc/unblock',
}

export default {
  create (
    payload: PackTraceCreateRequest,
    callback: ResponseCallback<PackTraceData>
  ) {
    api.post(routes.create, payload, callback)
  },

  paginate (
    params: PaginateRequest,
    callback: ResponseCallback<PackTracePaginateResponse>
  ) {
    api.get(routes.paginate, params, callback)
  },

  read (id: number, callback: ResponseCallback<PackTraceData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  validatePackCode (
    payload: PackTraceValidatePackCodeRequest,
    callback: ResponseCallback<PackTraceValidatePackCodeResponse>,
    errorCallback: ResponseAndErrorCallback
  ) {
    api.postAndError(routes.validatePackCode, payload, callback, errorCallback)
  },

  validatePalletCode (code: string, callback: ResponseCallback<PackTraceValidatePalletCodeResponse>) {
    const url = routeUtil.replaceParams(routes.validatePalletCode, { code })
    api.get(url, {}, callback)
  },

  upcUnblock (
    payload: ManagerUpcRequest,
    callback: ResponseCallback<PackTraceValidatePackCodeResponse>
  ) {
    api.post(routes.upcUnblock, payload, callback)
  }
}
